export default __webpack_public_path__ + "static/media/slg.22bd9d81.jpg";